module.exports = __webpack_public_path__ + "img/4_2.2c762fdf.jpg";